import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AlgConsensoService } from '../../../services/alg-consenso.service';

@Component({
  selector: 'alg-linear-contract-hero',
  templateUrl: './alg-linear-contract-hero.component.html',
  styleUrls: ['./alg-linear-contract-hero.component.scss']
})
export class AlgLinearContractHeroComponent implements OnInit {
    @Input() reverse: boolean;
    public productName$: Observable<string>;
    constructor(private consensoService: AlgConsensoService) {
      this.productName$ = this.consensoService.approvalProductName$;
    }

    ngOnInit() {
      
    }
}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-linear-contract-hero/alg-linear-contract-hero.component.ts